/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '/buyerscaddy-api';
}

/**
 * Parameters for `BuyersCaddyApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
